import { render, staticRenderFns } from "./createTerminal.vue?vue&type=template&id=1c8ab489&"
import script from "./createTerminal.vue?vue&type=script&lang=js&"
export * from "./createTerminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports